module.exports = __webpack_public_path__ + "img/sixpackcarrier06.663f68bd.jpg";